import React from 'react';
import { Box, Paper, Typography, Container, Alert } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

interface UnauthorizedProps {
  message?: string;
}

const Unauthorized: React.FC<UnauthorizedProps> = ({ 
  message = 'You are not authorized to access this application. Please provide a valid token in the URL parameters.' 
}) => {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center'
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            width: '100%',
            backgroundColor: 'background.paper',
            borderRadius: 2
          }}
        >
          <LockIcon
            sx={{
              fontSize: 80,
              color: 'error.main',
              mb: 2
            }}
          />
          
          <Typography variant="h4" gutterBottom color="error">
            Unauthorized Access
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {message}
          </Typography>

          <Alert severity="info" sx={{ mt: 2 }}>
            <Typography variant="body2">
              To access this application, you need a valid authentication token.
              Please contact your administrator to obtain a token.
            </Typography>
          </Alert>

          <Box sx={{ mt: 3 }}>
            <Typography variant="caption" color="text.secondary">
              MAADEN CARTO - GIS Platform
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Unauthorized;
